import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';

export function clientFinancialStrategyRemoveDocumentApi(path: string) {
  return {
    path,
    DELETE: () => api.delete<JsonApiResponseSingle>(path),
  };
}
